export default __webpack_public_path__ + "static/media/MTH-Color-logo.5d710bc1.svg";